import createLucideIcon from '../createLucideIcon';

const LayoutList = createLucideIcon('LayoutList', [
  [
    'rect',
    { width: '7', height: '7', x: '3', y: '14', rx: '1', key: '1bb6yr' },
  ],
  ['rect', { width: '7', height: '7', x: '3', y: '3', rx: '1', key: '1g98yp' }],
  ['line', { x1: '14', x2: '21', y1: '4', y2: '4', key: '1jpd8k' }],
  ['line', { x1: '14', x2: '21', y1: '9', y2: '9', key: 'z1w1u5' }],
  ['line', { x1: '14', x2: '21', y1: '15', y2: '15', key: 'evly31' }],
  ['line', { x1: '14', x2: '21', y1: '20', y2: '20', key: 'v5or0t' }],
]);

export default LayoutList;
